@import '../../styles/palette.scss';

.loader,
.loader:before,
.loader:after {
  animation: load7 1.8s infinite ease-in-out;
  border-radius: 50%;
  height: 2.5em;
  width: 2.5em;
}

.loader {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
  color: #b0bdbd;
  font-size: 0.5rem;
  text-indent: -9999em;
  -ms-transform: translateZ(0);
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.loader:before,
.loader:after {
  content: '';
  position: absolute;
  top: 0;
}

.loader:before {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
  left: -4.5em;
}

.loader:after {
  left: 4.5em;
}

@keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }

  40% {
    box-shadow: 0 2.5em 0 0;
  }
}

@keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }

  40% {
    box-shadow: 0 2.5em 0 0;
  }
}

.centerDiv {
  align-items: center;
  display: flex;
  height: 50vh;
  justify-content: center;
}
